import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import ChildHeader from '../../components/ChildHeader';
import ChildPages from '../../components/ChildPages';
import ChartCard from '../../components/ChartCard';
import Statistics from '../../components/Statistics';
import ResponsiveFooter from '../../components/ResponsiveFooter';

import relaxingIcon from '../../assets/physical/relaxing.png';
import activeHoursIcon from '../../assets/physical/activeHours.png';
import caloriesIcon from '../../assets/physical/calories.png';
import stepsIcon from '../../assets/physical/steps.png';

import { Container, Content } from './styles';

import { useListChildren } from '../../hooks/ParentContext';
import { useAuth } from '../../hooks/AuthContext';
import api from '../../services/api';

const Physical = () => {
  const token = localStorage.getItem("@Ocariot:token");
  const { selectedOne } = useListChildren();
  const { user } = useAuth();
  const [date, setDate] = useState()
  const [stats, setStats] = useState();
  const [percentages, setPercentages] = useState({});

  const getData = () => {

    let dateReq = new Date();
    const dd = String(dateReq.getDate()).padStart(2, '0');
    const mm = String(dateReq.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = dateReq.getFullYear();
    dateReq = yyyy + '-' + mm + '-' + dd

    let path = `statistics/activity/${selectedOne._id}/${dateReq}/${dateReq}/`
    //let path = `statistics/activity/${selectedOne._id}/2021-07-14/2021-07-14/`

    api.get(path, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        sort: 'day'
      }
    }).then((res) => {
      let hoursS = ("0" + String(Math.floor(res.data.data[0].sedentaryMinutes / 60))).substr(-2)
      let hoursA = ("0" + String(Math.floor(res.data.data[0].activeMinutes / 60))).substr(-2)

      let pActH = parseInt((res.data.data[0].activeMinutes / 60) * 100);
      let pCalB = (res.data.data[0].caloriesOut / 1200) * 100;
      let pStep = (res.data.data[0].steps / 10000) * 100;

      setPercentages({ pActH, pCalB, pStep })

      setStats({
        sedentaryMinutes: (("0" + String(Math.floor(res.data.data[0].sedentaryMinutes / 60))).substr(-2) + 'hs' + ("0" + String(Math.round(((res.data.data[0].sedentaryMinutes / 60) - hoursS) * 60))).substr(-2) + 'mins'),
        activeMinutes: (("0" + String(Math.floor(res.data.data[0].activeMinutes / 60))).substr(-2) + 'hs' + ("0" + String(Math.round(((res.data.data[0].activeMinutes / 60) - hoursA) * 60))).substr(-2) + 'mins'),
        caloriesOut: ((res.data.data[0].caloriesOut).toString() + 'cal'),
        steps: (res.data.data[0].steps).toString()
      })
    }).catch((err) => {
      console.log(err);
    });

  }

  useEffect(() => {
    let date = new Date();
    setDate(String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear())
    getData();
  }, [selectedOne])

  return (
    <Container>
      <Content>
        {user.type == 2 ? (
          <div className="first-header-line">
            <ChildHeader />
            <Link to="dashboard">Selecionar outra criança</Link>
          </div>
        ) : (
          <div className="first-header-line">
            <ChildHeader />
          </div>
        )}

        <div className="body">
          <div className="pages-child">
            <ChildPages active="physical" />
          </div>
          <div className="charts-body">
            <div className="main-chart">
              <p>Parâmetros de atividade física.</p>
              <ChartCard
                name="Atividade física"
                route="activity"
                labels={["Passos", "Horas sedentárias", "Horas ativas", "Calorias queimadas"]}
              />
            </div>
            <br />
            <div className="secondary-charts">
              <p>Estátiscas do dia atual: <strong>{date}</strong></p>
              <div className="atual-day">
                <Statistics icon={relaxingIcon} stringValue={stats ? stats.sedentaryMinutes : '00hs00mins'} name="Horas sedentárias" />
                <Statistics chartIcon={activeHoursIcon} stringValue={stats ? stats.activeMinutes : '00hs00mins'} value={percentages ? percentages.pActH : 0} name="Horas ativas" />
                <Statistics chartIcon={caloriesIcon} stringValue={stats ? stats.caloriesOut : '0'} value={percentages ? percentages.pCalB : 0} name="Calorias queimadas" />
                <Statistics chartIcon={stepsIcon} value={percentages ? percentages.pStep : 0} stringValue={stats ? stats.steps : '0'} name="Passos" />
                <ResponsiveFooter />
              </div>
            </div>
          </div>
        </div>
      </Content>
    </Container>
  );
}

export default Physical;